import { render, staticRenderFns } from "./BrandDetailsAddressField.vue?vue&type=template&id=0356ccb9&scoped=true&"
import script from "./BrandDetailsAddressField.vue?vue&type=script&lang=ts&"
export * from "./BrandDetailsAddressField.vue?vue&type=script&lang=ts&"
import style0 from "./BrandDetailsAddressField.vue?vue&type=style&index=0&id=0356ccb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0356ccb9",
  null
  
)

export default component.exports